import { isolateComponent } from '@zapier/style-encapsulation';
import { AccountsMenuLinks, moveZapsLink } from '../../constants';
import { useUniversalNavContext } from '../../hooks';
import useAccountsMenuData from './utils/useAccountsMenuData';
import AccountsMenu from './AccountsMenu';
const AccountsMenuContainer = (props) => {
    var _a;
    const { useQuery } = useUniversalNavContext();
    const result = useAccountsMenuData({ useQuery });
    const { data } = result;
    const accounts = ((data === null || data === void 0 ? void 0 : data.accounts) || []).map((account) => ({
        id: account.id,
        name: account.normalizedName,
        imageUrl: account.normalizedImageUrl,
    }));
    const menuLinks = [...AccountsMenuLinks];
    if (accounts.length > 1) {
        menuLinks.unshift(moveZapsLink);
    }
    const email = ((_a = data === null || data === void 0 ? void 0 : data.currentUserV2) === null || _a === void 0 ? void 0 : _a.email) || '';
    return (isolateComponent(AccountsMenu, Object.assign({ accounts: accounts, email: email, menuLinks: menuLinks }, props)));
};
export default AccountsMenuContainer;
//# sourceMappingURL=AccountsMenuContainer.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
